export const HOME = {
  emergentLink: "emergent-link",
  hero: "hero-carousel",
  heroPrev: "hero-prev-btn",
  heroNext: "hero-next-btn",
  heroDot: (i) => `hero-dot-${i}`,
  siddhaSection: "siddha-mala-section",
  sankalpSection: "sankalp-puja-section",
  higherMukhiSection: "higher-mukhi-section",
  exhibitionSection: "exhibition-section",
  kidsSection: "kids-section",
  footer: "site-footer",
  whatsappBtn: "whatsapp-float-btn",
};

export const NAV = {
  brand: "nav-brand",
  adminLink: "nav-admin-link",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logoutBtn: "admin-logout-btn",
  tab: (name) => `admin-tab-${name}`,
  addBtn: "admin-add-btn",
  saveBtn: "admin-save-btn",
  deleteBtn: (id) => `admin-delete-${id}`,
  editBtn: (id) => `admin-edit-${id}`,
};

export const SCROLL = {
  left: (name) => `${name}-scroll-left`,
  right: (name) => `${name}-scroll-right`,
  card: (name, id) => `${name}-card-${id}`,
};
